// extracted by mini-css-extract-plugin
export var backdropBlur = "_ib-0";
export var contentCard = "_ib-5";
export var frame = "_ib-2";
export var image = "_ib-4";
export var imagePane = "_ib-3";
export var modal = "_ib-1";